<template>
  <img :src="src" :style="style" />
</template>

<script>
import VueTypes from 'vue-types'

/**
 * 按比例缩放未知尺寸的图片
 * @desc 监听图片加载，在完成之前占位不显示，加载后获取宽高，显示图片
 * @module component/AutoImage
 * @example <AutoImage :src="imageUrl" :scale="50" />
 */
export default {
  name: 'auto-image',
  /**
   * 传入数据
   * @property {String}  [src]        图片地址
   * @property {Number}  [scale=100]  缩放的比例
   */
  props: {
    src: VueTypes.string.def(''),
    scale: VueTypes.number.def(100)
  },
  /**
   * 内部属性
   * @member
   * @property {Object} style                    图片的自定义样式
   * @property {String} style.visibility=hidden  默认为占位不显示，以便在加载后获取宽高
   */
  data () {
    return {
      style: {
        visibility: 'hidden'
      }
    }
  },
  mounted () {
    this.$el.addEventListener('load', this.handleLoading)
  },
  beforeDestroy () {
    this.$el.removeEventListener('load', this.handleLoading)
  },
  methods: {
    /**
     * 图片加载完后根据设定好的比例计算图片的宽高
     * @func
     */
    handleLoading () {
      this.style = {
        width: Math.floor(this.$el.width * this.scale / 100) + 'px',
        height: Math.floor(this.$el.height * this.scale / 100) + 'px',
        visibility: 'visible'
      }
    }
  }
}
</script>

 